export function validURL(str){
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

    if(!!pattern.test(str) == false){
        return 'Invalid URL address'
    }else{
        return true;
    }
}
export function required(v) {
    return (!!v || v===0) || 'This element is required';
}
export function requiredNotEmptyString(v) {
    if(typeof v=='string' && v.length > 0) return true;
    else return 'This element is required'
}

export function email(v) {
    return /.+@.+\..+/.test(v) || 'E-mail must be valid';
}
export function min1(v) {
    if(typeof v != 'object') return 'This element should contains at least 1 element';
    if(v.length == 0) return 'This element should contains at least 1 element';
    return true;
}

export function isMailUnique(email, emailArray){
    const filteredArray = emailArray.filter(singleEmail=> singleEmail.email === email);
    if(filteredArray.length>0) return 'Email address is already in use';
    return true;
}

export function price(v){
    if( typeof v != 'string' && typeof v != 'number') return  'Price is required';
    if(v < 0) return 'Price must be greater than 0';
    return true;
}

export function minProductPrice(currentValue, minPrice){
    if(parseFloat(currentValue)<parseFloat(minPrice)) return 'Price must be greater than or equal to '+minPrice;
    return true;
}

export function maxShippingPrice(currentValue, maxPrice){
    if( typeof currentValue != 'string' && typeof currentValue != 'number') return  'Price is required';
    if(parseFloat(currentValue)>parseFloat(maxPrice)) return 'Price must be smaller than or equal to '+maxPrice;
    return true;
}

export function minVal(v,minVal){
    if(parseFloat(v)<parseFloat(minVal)) return 'This element must be greater than or equal to '+minVal;
    return true;
}

export function minValRequired(v,minVal){
    if(parseFloat(v)<parseFloat(minVal)) return 'This element must be greater than or equal to '+minVal;
    if(parseFloat(v)!='0'){
        return !!v || 'This element is required';
    }
    return true;
}
